var dureeCycle = document.getElementById("duree_cycle"),
dureeRegles = document.getElementById("duree_regles"),
nbTampons = document.getElementById("nbTampons"),
nbServiettes = document.getElementById("nbServiettes"),
resultKgParAn = document.getElementById("results_kg_an"),
resultNBCulottes = document.getElementById("results_nb_culottes"),

btnsMoins = [...document.querySelectorAll(".btn_calculator__moins")],
btnsPlus = [...document.querySelectorAll(".btn_calculator__plus")];

calculeSave(dureeCycle, dureeRegles, nbTampons, nbServiettes)

btnsMoins.forEach(function (e) {
    e.addEventListener("click", function () {
        if(e.classList.contains("duree_cycle")){
            let dureeCycleV = parseInt(dureeCycle.innerText, 10);
            if(dureeCycleV > parseInt(e.getAttribute("data-min"))){
                dureeCycleV = dureeCycleV - 1;
                dureeCycle.innerText = dureeCycleV;
            }
        }
        else if(e.classList.contains("duree_regles")){
            let dureeReglesV = parseInt(dureeRegles.innerText, 10);
            if(dureeReglesV > parseInt(e.getAttribute("data-min"))){
                dureeReglesV = dureeReglesV - 1;
                dureeRegles.innerText = dureeReglesV;
            }
        }else if(e.classList.contains("nbTampons")){
            let nbTamponsV = parseInt(nbTampons.innerText, 10);
            if(nbTamponsV > parseInt(e.getAttribute("data-min"))){
                nbTamponsV = nbTamponsV - 1;
                nbTampons.innerText = nbTamponsV;
            }

        }else if(e.classList.contains("nbServiettes")){
            let nbServiettesV = parseInt(nbServiettes.innerText, 10);
            if(nbServiettesV > parseInt(e.getAttribute("data-min"))){
                nbServiettesV = nbServiettesV - 1;
                nbServiettes.innerText = nbServiettesV;
            }
        }
        calculeSave(dureeCycle, dureeRegles, nbTampons, nbServiettes);
    });
}),
btnsPlus.forEach(function (e) {
        e.addEventListener("click", function () {
            if(e.classList.contains("duree_cycle")){
                let dureeCycleV = parseInt(dureeCycle.innerText, 10);
                if(dureeCycleV < parseInt(e.getAttribute("data-max"))){
                    dureeCycleV = dureeCycleV + 1;
                    dureeCycle.innerText = dureeCycleV;
                }
            }
            else if(e.classList.contains("duree_regles")){
                let dureeReglesV = parseInt(dureeRegles.innerText, 10);
                if(dureeReglesV < parseInt(e.getAttribute("data-max"))){
                    dureeReglesV = dureeReglesV + 1;
                    dureeRegles.innerText = dureeReglesV;
                }
            }else if(e.classList.contains("nbTampons")){
                let nbTamponsV = parseInt(nbTampons.innerText, 10);
                if(nbTamponsV < parseInt(e.getAttribute("data-max"))){
                    nbTamponsV = nbTamponsV + 1;
                    nbTampons.innerText = nbTamponsV;
                }

            }else if(e.classList.contains("nbServiettes")){
                let nbServiettesV = parseInt(nbServiettes.innerText, 10);
                if(nbServiettesV < parseInt(e.getAttribute("data-max"))){
                    nbServiettesV = nbServiettesV + 1;
                    nbServiettes.innerText = nbServiettesV;
                }
            }
            calculeSave(dureeCycle, dureeRegles, nbTampons, nbServiettes);
        });
});
function calculeSave(dureeCycle, dureeRegles, nbTampons, nbServiettes){
    (dureeCycleValue = parseInt(dureeCycle.innerText, 10)), (dureeReglesValue = parseInt(dureeRegles.innerText, 10)), (nbTamponsValue = parseInt(nbTampons.innerText, 10)), (nbServiettesValue = parseInt(nbServiettes.innerText, 10));
        let calcule = (0.002 * nbTamponsValue * dureeReglesValue + 0.007 * nbServiettesValue * dureeReglesValue) * ((365 / dureeCycleValue) * dureeReglesValue),
            resultat1 = Math.round(10 * calcule) / 10,
            n = 50 / (0.27 * nbTamponsValue * dureeReglesValue + 0.24 * nbServiettesValue * dureeReglesValue),
            //resultat2 = Math.round(10 * n) / 10;
            resultat2 = Math.round(((nbTamponsValue * 0.19 * dureeReglesValue) + (nbServiettesValue * 0.21 * dureeReglesValue) ) * 12);
        //console.log(resultat2);
        resultKgParAn.innerText = resultat1.toString();
        if(resultat2.toString() === "Infinity"){
            resultNBCulottes.parentNode.style.display = "none";
        }else{
            resultNBCulottes.parentNode.style.display = "block";
            resultNBCulottes.innerText = resultat2.toString();
        }
}

//let heightNav = document.querySelector('#navigation').offsetHeight;
//let heightHeader = document.querySelector('#header').offsetHeight;
let ctaCalculImpact = document.getElementById('calcul-impact');
let ctaSavoirPlus = document.getElementById('savoir-plus');
let blocTechnologie = document.getElementById('technologie');

ctaSavoirPlus.addEventListener("click", (event) => {
  blocTechnologie.classList.add("active");
});

ctaCalculImpact.addEventListener("click", (event) => {
    let vwToPx;
    if (window.matchMedia("(max-width: 991px)").matches) {
        // Valeur spécifique pour mobile
        vwToPx = window.innerWidth * 0.15;
    } else {
        // Valeur spécifique pour les desktops
        vwToPx = window.innerWidth * 0.05;
    }
    let contPos = document.querySelector('#calculateur').offsetTop - vwToPx;
    //   if (window.matchMedia("(min-width: 960px)").matches) {
    //       contPos = parseInt(contPos) - parseInt(heightNav);
    //     } else {
    //       contPos = parseInt(contPos) - parseInt(heightHeader);
    //    }
    window.scroll({ top: contPos, behavior: "smooth" });
});





